// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> price-brothers-rise -> avignon-apartment-homes
// Generated: 2026-11-03T23:03:24.572Z
// Counts: 2 design, 86 content, 14 slot group, 1 collection binding, 7 section, 4 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently Asked Questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Avignon Apartment Homes, a pet-friendly community in Olathe, Kansas, offering <a class=\"richtext-link\" href=\"/floor-plans\"><u>one, two, and three-bedroom apartments</u></a> from 704 to 1,384 square feet. Each home includes a built-in wine cooler, an in-unit washer and dryer, and a garden-size tub, with select apartments adding an attached garage. Located near 119th Street and Greenwood Street, Avignon Apartment Homes keeps Kansas City, local shops, and top employers within easy access.</p><p></p><p>Residents enjoy luxury amenities, including a saltwater pool with an outdoor loggia and private cabanas, a game room with billiards and darts, steam rooms, tanning beds, and on-site massage therapy. Browse our <a class=\"richtext-link\" href=\"/amenities\"><u>community amenities</u></a>, view our <a class=\"richtext-link\" href=\"/gallery\"><u>photo gallery</u></a>, or <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>schedule a tour</u></a> of Avignon Apartment Homes today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "2-bedrooms-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>2-Bedroom Apartments in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "2-bedrooms-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>2 Bedrooms</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Our commitment to accessible living at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartment Amenities in Olathe, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Apartment Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Start your application for <span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Avignon Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Contact Us</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>A Closer Look At Our Showcase Layout at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Floor Plan</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1, 2 &amp; 3-Bedroom Apartments in Olathe, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Photos of Our Apartments for Rent in Olathe, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments in Olathe, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover modern living at Eastpark with in-unit laundry. Enjoy ultimate convenience in Denton, TX, where comfort meets stylish amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover apartments with poolside cabanas in Garland, TX. Luxury living with resort-style amenities is waiting for you.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Denton, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Poolside Cabanas in Garland TX Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Property Map | Avignon Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments Near JCCC in Olathe, KS 66062</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive Perks For Local Employees</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-intro.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to Claim Your Benefits?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Preferred Employer Partners</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Garmin</p></li><li><p>Honeywell</p></li><li><p>Active Military</p></li><li><p>University of Kansas Health System</p></li><li><p>Kiewit</p></li><li><p>Price Brothers Commercial Tenants</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Learn about pet-friendly living at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Unparalleled Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Review how <span data-type=\"field-token\" data-field=\"property_name\"></span> protects your personal information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Access your resident portal and community resources at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews for Avignon Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule a Tour at Avignon Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule A Tour</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Avignon Apartment Homes is part of the Price Brothers Management Co. portfolio, a family of communities across Kansas and Missouri. If Avignon Apartment Homes does not have the floor plan or location you need, explore our sister communities directly on this page.</p><p>Compare floor plans, amenities, and pricing at each community, or <a class=\"richtext-link\" href=\"/contact-us\"><u>contact Avignon Apartment Homes</u></a> if you have questions about availability.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Price Brothers Management Co. Communities Near Avignon Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate all pages on the <span data-type=\"field-token\" data-field=\"property_name\"></span> website</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Explore the Comfort &amp; Style Waiting for You!</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>The Epicenter of Luxury &amp; Convenience</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Location, Community, Quality living. It Starts Here!</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We appreciate your interest in&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Apartment Tours in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Avignon Apartment Homes, comfort and convenience come together throughout the community. Residents enjoy a saltwater pool with an outdoor loggia and private cabanas, a game room with billiards, darts, and video games, steam rooms, tanning beds, and on-site massage therapy, along with a business center, conference room, and event space with a prep kitchen and coffee bar.</p><p>Inside your <a class=\"richtext-link\" href=\"/floor-plans\"><u>one, two, or three-bedroom apartment</u></a>, enjoy an in-unit washer and dryer, a built-in wine cooler, a garden-size tub, hardwood entries, and spacious closets, with select homes offering an attached garage, a den or study, and a stone backsplash.</p><p></p><h2><strong>Olathe Perfection from Amenities to Ambiance</strong></h2><p></p><p>Every detail at Avignon Apartment Homes is designed with your comfort in mind. Explore our <a class=\"richtext-link\" href=\"/amenities\"><u>amenities</u></a> further, or <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>schedule a tour</u></a> to see them in person. We're just minutes from Johnson County Community College and MidAmerica Nazarene University.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for more information? Our team can answer questions about <a class=\"richtext-link\" href=\"/floor-plans\"><u>available floor plans</u></a>, <a class=\"richtext-link\" href=\"/amenities\"><u>community amenities</u></a>, pet policies, and <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>scheduling a tour</u></a>.</p><p></p><p>Call us at <a class=\"richtext-link\" href=\"tel:9135131489\">(913) 513-1489</a>, visit our leasing office at 11820 S Greenwood St, Olathe, KS 66062, or complete the contact form below. Office hours are Monday through Friday from 9:30 a.m. to 5:30 p.m. and Saturday from 10 a.m. to 5 p.m.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Find answers to common questions about applications, deposits, lease terms, pets, utilities, rent payments, and maintenance requests at Avignon Apartment Homes. You can also review our <a class=\"richtext-link\" href=\"/floor-plans\"><u>floor plans</u></a> and <a class=\"richtext-link\" href=\"/amenities\"><u>amenities</u></a> for more information.</p><p></p><p>If you do not see the answer you need, <a class=\"richtext-link\" href=\"/contact-us\"><u>contact our leasing team</u></a>. We are happy to help.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Answers About Our&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span> Community</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from a collection of one, two, and three-bedroom floor plans at Avignon Apartment Homes, ranging from 704 to 1,384 square feet. Every home includes an open-concept layout, a built-in wine cooler, in-unit laundry, and a garden-size tub, and select floor plans add an attached garage or a private den.</p><p></p><p><strong>Find the Olathe Apartment That Fits Your Life</strong></p><p></p><p>Step outside your apartment and enjoy the saltwater pool with an outdoor loggia and private cabanas, or spend an evening in the game room with billiards, darts, and video games.</p><p></p><p>Ready to see a floor plan in person? <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>Schedule a tour</u></a> of Avignon Apartment Homes today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our photo gallery for a glimpse of the elevated lifestyle waiting for you at Avignon Apartment Homes. We make it possible for you to live in comfort and luxury by offering a range of amenities and features to make you feel at home.</p><p></p><h2><strong>Your Intimate Retreat in Olathe, Kansas</strong></h2><p></p><p>When living at Avignon Apartments, you are at the center of it all. After a long day, you can enjoy our saltwater pool, game room, steam rooms, tanning beds, or massage therapy! Our upscale<a class=\"richtext-link\" href=\"/neighborhood\"> <u>apartments in Olathe, KS</u></a> feature built-in wine coolers, in-unit washer and dryer, and garden-size tubs. We have the perfect layout for you and your household, with one, two, or three-bedroom apartments ranging from 704 square feet and expanding to 1,384 square feet.</p><p></p><p>Avignon Apartment Homes is a pet-friendly community near Thomas S. Stoll Memorial Park and the Avignon shops, including Mi Ranchito, Birdcage Salon, and Four Paws Pantry &amp; Spa. After browsing, compare our <a class=\"richtext-link\" href=\"/floor-plans\"><u>floor plans</u></a> or <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>schedule a tour</u></a> of Avignon Apartment Homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Use our interactive property map to explore available apartments at Avignon Apartment Homes by building, floor plan, and location within the community. Filter by bedrooms, bathrooms, rent range, square footage, and move-in date to find the home that fits your needs.</p><p>Review our full list of <a class=\"richtext-link\" href=\"/floor-plans\"><u>floor plans</u></a> and <a class=\"richtext-link\" href=\"/amenities\"><u>amenities</u></a> for more details, or <a class=\"richtext-link\" href=\"/contact-us\"><u>contact us</u></a> to schedule a tour.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Avignon Apartment Homes is located at 11820 S Greenwood St, close to Strang Line Road and offers quick access to 119th Street, Highway 69, I-435, and I-35. The Avignon shops, including Mi Ranchito, Birdcage Salon, and Four Paws Pantry &amp; Spa, are just minutes away, and Kansas City is a short drive down the road.&nbsp;</p><p></p><h2><strong>Ideally Located Near Local Employers and Schools</strong></h2><p>Your daily commute is easier from Avignon Apartment Homes, with access to the Olathe School District, Johnson County Community College, and MidAmerica Nazarene University nearby.* Spend time outdoors at Thomas S. Stoll Memorial Park, just around the corner from our pet-friendly community.</p><p></p><p>Choose Avignon Apartment Homes as your new address, and open the door to a well-connected lifestyle. <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>Schedule a private tour</u></a> of our community today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Avignon Apartment Homes welcomes pets,* with a maximum of two pets per apartment. Monthly pet rent is $25 per pet, with a non-refundable fee of $300 for one pet or $500 for two pets. Restricted breeds include Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and mixes containing any of these breeds. Management may restrict additional breeds, and exotic, feral, or wild animals are not permitted. As a resident, your pet may qualify for the Price Brothers Pet Royalty Club with payment of the one-time pet fee. Learn more on the <a target=\"_blank\" class=\"richtext-link\" href=\"https://www.pricebrotherskc.com/\">Price Brothers Management Co. website</a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 24px;\"><strong>Superior Living, SUPERIOR SERVICE</strong></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Read what current residents have to say about life at Avignon Apartment Homes. Our reviews highlight the responsiveness of our maintenance team, the quality of our amenities, and the sense of community throughout the property.</p><p></p><p>Ready to see Avignon Apartment Homes for yourself? <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>Schedule a tour</u></a> or explore our <a class=\"richtext-link\" href=\"/floor-plans\"><u>floor plans</u></a> and <a class=\"richtext-link\" href=\"/amenities\"><u>amenities</u></a> today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>We would love to show you around. Select a date and time below to schedule your tour of Avignon Apartment Homes in Olathe, KS, or call our leasing office.<br></p><p>During your visit, take a closer look at our <a class=\"richtext-link\" href=\"/floor-plans\"><u>floor plans</u></a>, <a class=\"richtext-link\" href=\"/amenities\"><u>community amenities</u></a>, and <a class=\"richtext-link\" href=\"/gallery\"><u>photo gallery</u></a>. Our office is located at 11820 S Greenwood St, Olathe, KS 66062.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "galleryseparator.image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "hero.bg_image_2": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "hero.bg_image_3": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Creekside Apartment Homes living room image in Overland Park"
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Stonebriar Woods Apartment Homes interior in Overland Park"
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Somerset Oaks Apartment Homes interior in Olathe"
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Crowne Chase Apartment Homes interior in Overland Park"
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Stonebriar Apartment Homes interior in Overland Park"
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "The Claremont Apartment Homes interior in Overland Park"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_3362623ac7efcfc0b09a6f87",
      "ec_48d28e4eab639328442991ab",
      "ec_d2f072dbb5a390f37ba6ffb2",
      "ec_232f3495a887e200865eba3f",
      "ec_3f650047adf9b4c28c714424",
      "ec_4fdce41a0b343274ec7cbc53",
      "ec_f68dca8bce16a4517b688f51",
      "ec_344a19f78858bbf24f26c333",
      "ec_66a86f319a563d346fd3d41a",
      "ec_d633104e6bbe07bcde60e9d5",
      "ec_155825318ea5b3bda29ad9fe",
      "ec_c5f4f1d545066fa2f212db1c",
      "ec_0aa957e8dabb7816e02b6b98",
      "ec_ea8b0364c11d4c73e6b3c209",
      "ec_18e88fd86ef72b7fed7dc190",
      "ec_0463febf3747c9bbc7933795",
      "ec_6fcd84955c555ee768049bd1",
      "ec_b03eb4a7ab10fe20f5699b48"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  },
  "propertyoverview.pre_title": {
    "properties": {
      "fontWeight": "600"
    }
  },
  "galleryapartments.heading": {
    "properties": {
      "color": "#b3a369"
    }
  },
  "gallerycommunity.heading": {
    "properties": {
      "color": "#B3A369"
    }
  }
};
